import React from 'react';
import { bool, shape, string } from 'prop-types';

const WorkGroupColor = ({
  className = 'icon',
  notUseClass = false,
  color = '#696f88',
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={{ color, ...style }} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_23574_206102)">
      <path d="M6 6.37573H4.5V5.07788C3.1275 6.17288 2.25 7.86073 2.25 9.75073C2.25 12.8032 4.54501 15.3305 7.5 15.698V17.2134C3.7125 16.8384 0.75 13.6432 0.75 9.75073C0.75 7.50823 1.74029 5.49823 3.30029 4.12573H1.5V2.62573H6V6.37573Z" fill="currentColor" />
      <path d="M15.75 9.75073C15.75 11.9932 14.7597 14.0032 13.1997 15.3757H15V16.8757H10.5V13.1257H12V14.4236C13.3725 13.3211 14.25 11.6407 14.25 9.75073H15.75Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M4.54468 7.50146C5.54604 7.56127 6.83563 7.82014 7.74902 8.8147C8.63087 9.7749 8.82422 10.5938 8.82422 10.5938C8.82422 10.5938 9.75 10.5 11.0413 9.75C11.0413 9.75 11.625 10.4999 12 10.9241C11.0562 11.5279 9.98995 11.8088 9 11.9333V15H7.5V13.4231C6.60519 13.2803 5.61679 12.9258 4.89624 12.0674L4.89331 12.063C4.01353 10.9996 3.80009 9.47092 3.75073 8.28149C3.74194 8.06959 3.82353 7.86393 3.97485 7.71533C4.12617 7.56675 4.33299 7.48883 4.54468 7.50146ZM5.32544 9.11938C5.43274 9.91615 5.65116 10.6254 6.04688 11.105C6.39006 11.5127 6.87203 11.7515 7.42456 11.8813C7.31729 11.0846 7.09873 10.3754 6.70312 9.89575C6.35994 9.48799 5.87798 9.2492 5.32544 9.11938Z" fill="currentColor" />
      <path d="M15 5.25H13.125V6H10.5V4.125H15V5.25Z" fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd" d="M13.125 1.875H16.125C16.7438 1.875 17.25 2.38125 17.25 3V7.55786C17.25 7.93474 16.9404 8.25 16.5579 8.25H9.375C8.75625 8.25 8.25 7.74375 8.25 7.125L8.25586 1.875C8.25586 1.25625 8.75625 0.75 9.375 0.75H12L13.125 1.875ZM9.375 7.125H16.125V3H12.6584L11.5334 1.875H9.375V7.125Z" fill="currentColor" />
    </g>
    <defs>
      <clipPath id="clip0_23574_206102">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

WorkGroupColor.propTypes = {
  className: string,
  notUseClass: bool,
  color: string,
  style: shape({}),
};

export default WorkGroupColor;
